import { BreadcrumpComponent } from "../components/subcomponents/BreadcrumpCompont";
import { PageSectionHeader } from "../components/subcomponents/PageSectionHeader";
import bigCover from '../assets/images/big-cover.jpg';
import { Link } from "react-router-dom";
import { Colors } from "../utils/utils.colors";
import { routes } from "../utils/utils.routes";

export const Anciens: React.FC = () => {
  return (
    <>
      <BreadcrumpComponent
        title="Anciens de l'ULPGL"
        subtitle="Restez connecté avec votre alma mater et retrouvez les anciens étudiants de l'Université Libre des Pays des Grands Lacs."
        imageCover={bigCover}
      />

      <div className="padding-x site-content" style={{ paddingTop: '3rem', paddingBottom: '4rem' }}>
        <main className="wp-block-group alignfull has-global-padding is-layout-constrained wp-block-group-is-layout-constrained">
          <PageSectionHeader
            eyebrow="Alumni"
            title="Réseau des Anciens"
            lead="L'ULPGL compte des milliers d'anciens étudiants à travers le monde, acteurs du changement dans divers secteurs. Rejoignez le réseau et participez à la vie de l'université."
            align="center"
          />

          <div className="wp-block-columns is-layout-flex" style={{ gap: '2rem', marginTop: '2rem' }}>
            <div className="wp-block-column" style={{ background: '#fff', borderRadius: 12, padding: '2rem', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', textAlign: 'center' }}>
              <div style={{ fontSize: 40, marginBottom: '1rem' }}>🎓</div>
              <h3 style={{ fontSize: 18, fontWeight: 700, color: Colors.darkColor, margin: '0 0 0.75rem' }}>Rester connecté</h3>
              <p style={{ fontSize: 14, color: '#666', lineHeight: 1.6, margin: 0 }}>
                Inscrivez-vous à l'annuaire des anciens pour recevoir les actualités de l'université et retrouver vos camarades de promotion.
              </p>
            </div>

            <div className="wp-block-column" style={{ background: '#fff', borderRadius: 12, padding: '2rem', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', textAlign: 'center' }}>
              <div style={{ fontSize: 40, marginBottom: '1rem' }}>💼</div>
              <h3 style={{ fontSize: 18, fontWeight: 700, color: Colors.darkColor, margin: '0 0 0.75rem' }}>Opportunités</h3>
              <p style={{ fontSize: 14, color: '#666', lineHeight: 1.6, margin: 0 }}>
                Accédez aux offres de stage, d'emploi et aux appels à projets partagés par les anciens et les partenaires de l'ULPGL.
              </p>
            </div>

            <div className="wp-block-column" style={{ background: '#fff', borderRadius: 12, padding: '2rem', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', textAlign: 'center' }}>
              <div style={{ fontSize: 40, marginBottom: '1rem' }}>🤝</div>
              <h3 style={{ fontSize: 18, fontWeight: 700, color: Colors.darkColor, margin: '0 0 0.75rem' }}>Contribuer</h3>
              <p style={{ fontSize: 14, color: '#666', lineHeight: 1.6, margin: 0 }}>
                Participez au développement de votre université à travers le mentorat, les dons ou les partenariats.
              </p>
            </div>
          </div>

          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <p style={{ fontSize: 14, color: '#888' }}>
              La plateforme Alumni ULPGL est en cours de déploiement. Pour toute information, contactez le rectorat :{' '}
              <a href="mailto:rectorat@ulpgl.net" style={{ color: Colors.primaryColor, fontWeight: 600 }}>rectorat@ulpgl.net</a>
            </p>
            <Link
              to={routes.CONTACTS}
              style={{
                display: 'inline-block', marginTop: '1rem',
                padding: '12px 32px', borderRadius: 8,
                background: Colors.primaryColor, color: '#fff',
                fontSize: 15, fontWeight: 600, textDecoration: 'none',
              }}
            >
              Nous contacter
            </Link>
          </div>
        </main>
      </div>
    </>
  );
};
